import { useMemo } from "react";
import { Section } from "views/applications-id-report/components/Section";
import { CombinedIncome } from "../../types/income";
import { mapIncomeSourceStatus } from "../../helpers";
import { IncomeType } from "shared/types";
import { BankStatements } from "../../types";
import { BankStatementWarning } from "./components/BankStatementWarning";
import { IncomeSourceWarning } from "./components/IncomeSourceWarning";
import { has } from "shared/utils";

export const DocumentWarnings = ({
  incomes,
  bankStatements = {}
}: {
  incomes: CombinedIncome[];
  bankStatements?: BankStatements;
}) => {
  const incomeSourceItems = useMemo(
    () =>
      incomes
        .map((inc) => mapIncomeSourceStatus(inc))
        .filter(
          (incSource) =>
            incSource.status && incSource.type !== IncomeType.HousingAssistance
        ),
    [incomes]
  );
  const incomeSourceWarnings = incomeSourceItems.filter(
    (incSource) => incSource.status === "Warning"
  );
  const incomeSourceErrors = incomeSourceItems.filter(
    (incSource) => incSource.status === "Rejected"
  );

  const unusedBankStatements = useMemo(
    () =>
      Object.values(bankStatements).filter((bankStatement) => {
        return !bankStatement.items?.some((transaction) =>
          has(transaction.income_id)
        );
      }),
    [bankStatements]
  );

  if (incomeSourceWarnings.length + unusedBankStatements.length === 0)
    return null;

  return (
    <Section sectionTitle="Warnings" maxWidth="none">
      <div className="flex flex-col gap-4">
        {incomeSourceWarnings.map(
          ({ incomeName, incomeId, description, status }) => (
            <IncomeSourceWarning
              key={incomeId}
              incomeId={incomeId}
              incomeName={incomeName}
              description={description}
              status={status}
            />
          )
        )}
        {unusedBankStatements.map((bankStatement) => (
          <BankStatementWarning
            key={bankStatement.raw_data?.id}
            bankStatement={bankStatement}
          />
        ))}
        {incomeSourceErrors.map(
          ({ incomeName, incomeId, description, status }) => (
            <IncomeSourceWarning
              key={incomeId}
              incomeId={incomeId}
              incomeName={incomeName}
              description={description}
              status={status}
            />
          )
        )}
      </div>
    </Section>
  );
};
